import { RootState } from 'constants/interfaces'
import { createSelector } from 'reselect'

const generalSelector = (state: RootState) => state.general

export const isRtlSelector = createSelector(generalSelector, (general) => general.locale === 'he')
